/* routing */
import router from "./router";

import { createApp } from "vue";
import App from "./App.vue";

/* component imports */
import PolaroidPic from "./components/PolaroidPic.vue";
import ProjectPreview from "./components/ProjectPreview.vue";
import FilterTagButton from "./components/FilterTagButton.vue";

/* fontAwesome imports */
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* import specific icons */
import {
  faEarthAmericas,
  faRoute,
  faPenRuler,
  faMapLocationDot,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

/* add icons to the library */
library.add(
  faEarthAmericas,
  faRoute,
  faPenRuler,
  faMapLocationDot,
  faGithub,
  faLinkedin,
  faXmark
);

const app = createApp(App);
app.component("polaroid-pic", PolaroidPic);
app.component("project-preview", ProjectPreview);
app.component("filter-tag-button", FilterTagButton);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);

app.mount("#app");
